import React, { Component, PropTypes } from 'react'

import { sendPatchRequest, smartPhoneOptions, yesNoOptions } from '../utils'

import { RadioInput, Select, TextInput } from '../ui'

export default class SmartphoneForm extends Component {
    static propTypes = {
        data: PropTypes.object,
        errors: PropTypes.object.isRequired,
        updateValue: PropTypes.func.isRequired,
        updateValueAndSendPatchRequest: PropTypes.func.isRequired,
    }

    render() {
        const errors = this.props.errors

        if (! this.props.data) {
            return null
        }

        let smartPhoneDetailsForm = null

        if (this.props.data.own_smart_phone === 1) {
            smartPhoneDetailsForm = (
                <div className="grid grid--break-mobile">
                    <div className="grid__span-4">
                        <Select
                            error={ errors.smart_phone_os_type }
                            label="OS Type"
                            name="smart_phone_os_type"
                            options={ smartPhoneOptions() }
                            placeholder="Select OS type"
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.smart_phone_os_type }
                        />
                        <TextInput
                            error={ errors.smart_phone_model_name }
                            handleBlur={ sendPatchRequest.bind(this, 'smart_phone_model_name') }
                            label="Model Name"
                            name="smart_phone_model_name"
                            placeholder="Year (eg: iPhone 6)"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.smart_phone_model_name }
                        />
                    </div>
                </div>
            )
        }

        return (
            <div className="form">
                <div className="grid grid--break-mobile">
                    <div className="grid__span-4">
                        <RadioInput
                            error={ errors.own_smart_phone }
                            label="Do you have a smart phone?"
                            name="own_smart_phone"
                            options={ yesNoOptions() }
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.own_smart_phone }
                        />
                    </div>
                </div>

                { smartPhoneDetailsForm }
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./app/components/personal/smartphone_form.js